module.exports = __webpack_public_path__ + "static/tip_1-cdf9c2f126ddcae3dd47208f90ab751b.jpg";